import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-unit-picker',
  templateUrl: './unit-picker.component.html',
  styleUrls: ['./unit-picker.component.scss'],
  standalone: false,
})
export class UnitPickerComponent implements OnInit {
  @Input()
  public preselectedItem: string;
  public items: string[] = ['t', 'm³', 'kg', 'm', 'm²', 'l', 'Stk'];
  @Output()
  public selectedItemChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}
}
